import { render } from "./InfiniteLoadingListStudy.vue?vue&type=template&id=1acd8631&scoped=true"
import script from "./InfiniteLoadingListStudy.vue?vue&type=script&lang=js"
export * from "./InfiniteLoadingListStudy.vue?vue&type=script&lang=js"

import "./InfiniteLoadingListStudy.vue?vue&type=style&index=0&id=1acd8631&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acd8631"]])

export default __exports__